import type { Idioma } from './tipos';

/**
 * Locale do navegador para cada idioma. Data, número e moeda saem daqui em vez
 * de `'pt-BR'` fixo no meio da tela — trocar o idioma tem que virar 08/12/2026
 * em 12/08/2026, senão a data engana quem lê em inglês.
 */
export const LOCALE: Record<Idioma, string> = {
  pt: 'pt-BR',
  en: 'en-US',
};

/** Moeda continua BRL nos dois idiomas: o dado é faturamento em real. */
const MOEDA = 'BRL';

type EntradaData = Date | string | number | null | undefined;

function paraData(valor: EntradaData): Date | null {
  if (valor === null || valor === undefined || valor === '') return null;
  const data = valor instanceof Date ? valor : new Date(valor);
  return Number.isNaN(data.getTime()) ? null : data;
}

export function formatarData(idioma: Idioma, valor: EntradaData, opcoes?: Intl.DateTimeFormatOptions): string {
  const data = paraData(valor);
  if (!data) return '-';
  return data.toLocaleDateString(LOCALE[idioma], opcoes);
}

export function formatarDataHora(idioma: Idioma, valor: EntradaData, opcoes?: Intl.DateTimeFormatOptions): string {
  const data = paraData(valor);
  if (!data) return '-';
  return data.toLocaleString(LOCALE[idioma], opcoes);
}

export function formatarNumero(idioma: Idioma, valor: number | null | undefined, opcoes?: Intl.NumberFormatOptions): string {
  if (valor === null || valor === undefined || Number.isNaN(valor)) return '-';
  return valor.toLocaleString(LOCALE[idioma], opcoes);
}

export function formatarMoeda(idioma: Idioma, valor: number | null | undefined): string {
  if (valor === null || valor === undefined || Number.isNaN(valor)) return '-';
  return valor.toLocaleString(LOCALE[idioma], { style: 'currency', currency: MOEDA });
}

/** Nome do mês por índice 0-11, para eixo de gráfico e cabeçalho de relatório. */
export function nomeMes(idioma: Idioma, mes: number, formato: 'long' | 'short' = 'long'): string {
  return new Date(2000, mes, 1).toLocaleDateString(LOCALE[idioma], { month: formato });
}
